import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import TitleSection from 'Views/Page/Content/Modal/Components/TitleSection';
import WhatIfStepNavigator from 'Views/Page/Content/Modal/Components/WhatIfStepNavigator';
import fr from 'facet-rest';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';

const styles = (theme) => ({
  root: {},
  amountByYear: {
    padding: theme.spacing(3, 0),
  },
  dataCellContainer: {
    display: 'flex',
    gap: '1rem', // theme.spacing(2) won't work
  },
  label: {
    color: theme.palette.facet.primaryGrey,
  },
  value: {
    color: theme.palette.facet.primaryBlue,
    fontSize: theme.typography.fontSize1Pt25Rem,
    fontWeight: theme.typography.fontWeightBold,
  },
});

const FacetPlanEducationOutcomeSummaryStepLayout = ({
  className,
  classes,
}) => {
  const { loadModalCollectionByLink } = useModalContext();

  const {
    resource,
    onSubmit,
    saving,
  } = useMetaLayoutContext();

  const previousLink = resource.relationship(fr.relationships.previousLink.name)?.link('related');
  const resourceMeta = resource.meta();

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <TitleSection />
      <Box className={classNames(classes.dataCellContainer)}>
        <Box>
          <Typography test="education-outcome-summary-goal-amount" className={classes.label}>{resourceMeta.field('goalAmount').attr('prompt')}</Typography>
          <Typography className={classes.value}>{resource.attr('goalAmount')}</Typography>
        </Box>
        <Box>
          <Typography className={classes.label}>{resourceMeta.field('endDate').attr('prompt')}</Typography>
          <Typography className={classes.value}>{resource.attr('endDate')}</Typography>
        </Box>
      </Box>
      <Box className={classes.amountByYear}>
        {resource.attr('amountPerYear').resources().list().map(r => {
          const amountMeta = r.meta();
          return (
            <Box className={classNames(classes.dataCellContainer)}>
              <Box>
                <Typography className={classes.label}>{amountMeta.field('amount').attr('prompt')}</Typography>
                <Typography className={classes.value}>{r.attr('year')}: {r.attr('amount')}</Typography>
              </Box>
            </Box>
          );
        })}
      </Box>

      <WhatIfStepNavigator
        isLoading={saving}
        onNext={() => {
          onSubmit();
        }}
        onPrevious={(previousLink) ? () => {
          loadModalCollectionByLink(previousLink.url());
        } : null}
      />
    </Box>
  );
};

FacetPlanEducationOutcomeSummaryStepLayout.defaultProps = {
  className: '',
};

FacetPlanEducationOutcomeSummaryStepLayout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FacetPlanEducationOutcomeSummaryStepLayout);
